import monitoringService from '../services/monitoringService';
import { API_URL, MONITORING_API_URL } from '../config/connect';

// Store original fetch
const originalFetch = window.fetch;

// Track if interceptor is already set up
let isInterceptorSetup = false;

/**
 * Setup API interceptor to track all API requests
 */
export function setupApiInterceptor() {
  if (isInterceptorSetup) {
    return;
  }

  // Override fetch
  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const options = args[1] || {};
    const method = options.method || 'GET';

    // Skip monitoring endpoints to avoid infinite loops
    if (url.includes('/monitoring/events') || url.startsWith(MONITORING_API_URL)) {
      return originalFetch.apply(this, args);
    }

    // Extract endpoint (remove base URL)
    let endpoint = url;
    if (url.startsWith(API_URL)) {
      endpoint = url.replace(API_URL, '');
    }

    let statusCode = null;
    let errorMessage = null;

    try {
      const response = await originalFetch.apply(this, args);
      statusCode = response.status;
      
      // Track success
      if (response.ok) {
        monitoringService.trackApiRequestSuccess(endpoint, method, statusCode).catch(err => {
          console.warn('Failed to track API success:', err);
        });
      } else {
        // Track failure
        try {
          const errorData = await response.clone().json().catch(() => null);
          errorMessage = errorData?.detail?.message || 
                        errorData?.message || 
                        errorData?.detail || 
                        `${response.status} ${response.statusText}`;
        } catch (e) {
          errorMessage = `${response.status} ${response.statusText}`;
        }
        
        monitoringService.trackApiRequestFailure(endpoint, method, statusCode, errorMessage).catch(err => {
          console.warn('Failed to track API failure:', err);
        });
      }
      
      return response;
    } catch (error) {
      statusCode = 0;
      errorMessage = error.message || 'Network error';
      
      // Track network error
      monitoringService.trackApiRequestFailure(endpoint, method, statusCode, errorMessage).catch(err => {
        console.warn('Failed to track API error:', err);
      });
      
      throw error;
    }
  };

  isInterceptorSetup = true;
}

/**
 * Remove API interceptor (restore original fetch)
 */
export function removeApiInterceptor() {
  if (!isInterceptorSetup) {
    return;
  }
  
  window.fetch = originalFetch;
  isInterceptorSetup = false;
}

